import Immutable from "immutable";

const modalProfileState = Immutable.Map({
  name: "",
  role: "agent",
  avatarUploading: false,
  userLoading: false,
  passwordReset: false,
  isOldPasswordShown: false,
  isPasswordShown: false,
  isPasswordResetValid: false
});

export const modalProfile = (state = modalProfileState, action) => {
  switch (action.type) {
    case "SET_MODAL_PROFILE":
      return state.merge(action.payload);
    case "UPDATE_PASSWORD_SUCCESS":
      return state.merge({
        passwordReset: true
      });
    case "AVATAR_UPLOAD_REQUEST":
      return state.set("avatarUploading", true);
    case "AVATAR_UPLOAD_FAILURE":
      return state.set("avatarUploading", false);
    case "AVATAR_UPLOAD_SUCCESS":
      return state.set("avatarUploading", false);
    default:
      return state;
  }
};
